<template>
  <div>
    <v-col offset-md="3" :md="6">
      <h1 class="primary--text text-center">
        Pool Entry for {{ userObject.userFName }}  {{ userObject.userLName }}
      </h1>
      <h3 class="primary--text text-center">
        Pool Name: {{ poolObject.poolName }}
      </h3>
      <div v-if="poolObject.tournamentType == 'L' || poolObject.tournamentType == 'B'">
        <v-card v-for="(item, index) in uPoolEntryList" :key="index" class="my-3 py-2">
          <v-row class="mx-5">
            Game #{{ index + 1 }}
            <v-spacer></v-spacer>
            On {{ convDate(item.gameDate) }} @ {{ item.gameVenue }}
          </v-row>
          <v-row class="mx-10">
            <div class="text-center" :class="[ (item.resultEntry == 'A' || item.resultEntry == 'X') ? 'primary' : '' ]">
              {{ item.memberA }} ({{ item.oddA }})
            </div>
            <v-spacer></v-spacer>
            <div class="text-center" :class="[ (item.resultEntry == 'B' || item.resultEntry == 'X') ? 'primary' : '' ]">
              {{ item.memberB }} ({{ item.oddB }})
            </div>
          </v-row>
          <div v-if="bonusUsed.length > 0">
            <div class="mx-10" v-for="(bon, bIndex) in bonusUsed" :key="bIndex">
                <div class="text-center">
                  {{ bon.bonusName }} - {{ item.bonusEntry[bIndex].bonusEntry }}
                </div>
            </div>
          </div>
        </v-card>
      </div>
      <div v-if="poolObject.tournamentType == 'B' || poolObject.tournamentType == 'K'">
        <h3 class="primary--text text-center">
          Knockout Qualifiers
        </h3>
        <div v-for="(entry, index) in uPoolKOEntryList" :key="index">
          <h4 class="primary--text text-center">{{ getKOValue(entry.koLevel) }}</h4>
          <div v-for="team in entry.koLevelEntry" :key="team" class="text-center">
            {{ team }}
          </div>
        </div>
      </div>
      <v-row class="my-6">
        <v-spacer></v-spacer>
        <v-btn color="primary" width="100" outlined @click="goBack">Ok</v-btn>
        <v-spacer></v-spacer>
      </v-row>
    </v-col>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'view-entry',
  props: [
    'poolObject', 'userObject',
  ],
  computed: {
    ...mapGetters([
      'uPoolEntryList', 'uPoolEntryLoaded',
      'uPoolKOEntryList', 'uPoolKOEntryLoaded',
      'bonusPointList', 'bonusPointLoaded'
    ])
  },
  watch: {
    bonusPointLoaded: function() {
      this.bonusUsed.splice(0)
      if (this.bonusPointList.length > 0) {
        for (var i=0; i<this.poolObject.bonusUsed.length; i++) {
          var bp = this.poolObject.bonusUsed[i]
          var obj = this.bonusPointList.find(elem => elem.bonusId == bp)
          if (obj) {
            this.bonusUsed.push(obj)
          }
        }
      }
    },
    userObject: function() {
      this.$store.dispatch('getUserPoolEntryList', { poolId: this.poolObject.poolId, userId: this.userObject.userId })
      this.$store.dispatch('getUserPoolKOEntryList', { poolId: this.poolObject.poolId, userId: this.userObject.userId })
      this.$store.dispatch('getBonusPointList', this.poolObject.sportId)
    },
    poolObject: function() {
      this.$store.dispatch('getUserPoolEntryList', { poolId: this.poolObject.poolId, userId: this.userObject.userId })
      this.$store.dispatch('getUserPoolKOEntryList', { poolId: this.poolObject.poolId, userId: this.userObject.userId })
      this.$store.dispatch('getBonusPointList', this.poolObject.sportId)
    }
  },
  data: () => ({
    bonusUsed: [],
    koValues: ['Winner', 'Finalists', 'Semi-FInalists', 'Quarter-Finalists', 'Round of 16', 
                  'Round of 32', 'Round of 64', 'Round of 128', 'Round of 256'],
  }),
  created() {
    this.$store.dispatch('getUserPoolEntryList', { poolId: this.poolObject.poolId, userId: this.userObject.userId })
    this.$store.dispatch('getUserPoolKOEntryList', { poolId: this.poolObject.poolId, userId: this.userObject.userId })
    this.$store.dispatch('getBonusPointList', this.poolObject.sportId)
  },
  methods: {
    convDate(inDate) {
      return inDate.substring(0, 10)
    },
    getKOValue(value) {
      return this.koValues[Math.log2(value)]
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>